import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RoutePipe } from './pipes/route.pipe';
import { PageTitleComponent } from '../components/common/page-title/page-title.component';
import { ServicesAreaComponent } from '../components/common/services-area/services-area.component';
import { AboutAreaComponent } from '../components/common/about-area/about-area.component';
import { FeaturesServicesAreaComponent } from '../components/common/features-services-area/features-services-area.component';
import { IntegrationImagesComponent } from '../components/common/integration-images/integration-images.component';
import { FaqAreaComponent } from '../components/common/faq-area/faq-area.component';
import { PricingComponent } from '../components/common/pricing/pricing.component';
import { PartnerComponent } from '../components/common/partner/partner.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    RoutePipe,
    PageTitleComponent,
    ServicesAreaComponent,
    AboutAreaComponent,
    FeaturesServicesAreaComponent,
    IntegrationImagesComponent,
    FaqAreaComponent,
    PricingComponent,
    PartnerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  exports: [
    RoutePipe,
    PageTitleComponent,
    ServicesAreaComponent,
    AboutAreaComponent,
    FeaturesServicesAreaComponent,
    IntegrationImagesComponent,
    FaqAreaComponent,
    PricingComponent,
    PartnerComponent,
    RouterModule,
    TranslateModule
  ]
})
export class SharedModule { }
